/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Use_Picker_Empty_Viewing_TasksInputs */

const cs_templates_use_picker_empty_viewing_tasks = /** @type {(inputs: Templates_Use_Picker_Empty_Viewing_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný úkol prohlídky v tomto rozsahu. Otevřete seznam prohlídek a protokol vygenerujte na úkolu.`)
};

const en_templates_use_picker_empty_viewing_tasks = /** @type {(inputs: Templates_Use_Picker_Empty_Viewing_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No viewing tasks in this scope. Open the viewing tasks list and generate the protocol on a task.`)
};

/**
* | output |
* | --- |
* | "No viewing tasks in this scope. Open the viewing tasks list and generate the protocol on a task." |
*
* @param {Templates_Use_Picker_Empty_Viewing_TasksInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_use_picker_empty_viewing_tasks = /** @type {((inputs?: Templates_Use_Picker_Empty_Viewing_TasksInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Use_Picker_Empty_Viewing_TasksInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_use_picker_empty_viewing_tasks(inputs)
	return cs_templates_use_picker_empty_viewing_tasks(inputs)
});